export const getDataOrNil = (...args: (number | undefined | null)[]): number => {
  for (const arg of Array.from(args)) {
    if (arg) {
      return arg
    }
  }

  return 0
}
